import { ChangeDetectionStrategy, Component, ElementRef, ViewEncapsulation, inject, input, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalSearchService } from 'src/app/core/services/global-search-service';
import { MainComponent } from '../../main/main.component';

@Component({
	selector: 'app-global-search-bar',
	templateUrl: './global-search-bar.component.html',
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class GlobalSearchBarComponent {
	readonly collapsed = input<boolean>(false);

	protected readonly search = inject(GlobalSearchService);
	private readonly router = inject(Router);
	private readonly appMain = inject(MainComponent);

	private readonly searchInput = viewChild<ElementRef<HTMLInputElement>>('searchInput');

	readonly placeholder = 'Search for...';
	readonly tooltip = 'Search for...';

	onSubmit(): void {
		const term = this.search.submit();
		if (!term) return;
		this.router.navigate([GlobalSearchService.ResultsRoute], { queryParams: { q: term } });
		this.search.clearInput();
	}

	onClear(): void {
		this.search.clearInput();
		this.focusInput();
	}

	onExpandAndFocus(): void {
		this.appMain.toggleSidebarCollapsed();
		setTimeout(() => this.focusInput(), 0);
	}

	private focusInput(): void {
		this.searchInput()?.nativeElement.focus();
	}
}
